/* eslint-disable import/prefer-default-export */

export const TILE_SIZE_REM = 4;
export const F_TILE_SIZE_REM = `${TILE_SIZE_REM}rem`;

export const ENG_DICTIONARY_URL = 'http://localhost:8080/exampleDict.txt';
